import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@jsverse/transloco';

import {SharedModule} from '../../shared/shared.module';
import {CoreModule} from '../../core/core.module';

import {HomeComponent} from './home.component';

@NgModule({
  declarations: [
    HomeComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,

    SharedModule,
    CoreModule,
  ],
})
export class HomeModule {
}
